// Common
export const BASE_URL = (window as any).env?.REACT_APP_BASE_URL || (process as any).env?.REACT_APP_BASE_URL || "";
export const DATALAKE_URL =
  (window as any).env?.REACT_APP_DATALAKE_URL || (process as any).env?.REACT_APP_DATALAKE_URL || "";
export const GST_URL = (window as any).env?.REACT_APP_GST_URL || (process as any).env?.REACT_APP_GST_URL || "";
export const SAILOR_URL = (window as any).env?.REACT_APP_SAILOR_URL || (process as any).env?.REACT_APP_SAILOR_URL || "";

export const HEADER_DEFAULT = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const HEADER_DEFAULT_UPLOAD_FILE = {
  ...HEADER_DEFAULT,
  // "Accept-Encoding": "gzip, deflate",
  "content-type": "multipart/form-data; boundary=<calculated when request is sent>",
};

export const HEADER_DOWNLOAD_ZIP = {
  Accept: "*/*",
};

export const TIMEOUT = 300000;

// HTTP Status
export enum HTTP_STATUS {
  STT_OK = 200,
  STT_BAD_REQUEST = 400,
  STT_UNAUTHORIZED = 401,
  STT_OTP_EXPIRED = 402,
  STT_FORBIDDEN = 403,
  STT_NOT_FOUND = 404,
  STT_INTERNAL_SERVER = 500,
  STT_DUPLICATE_MESSAGE = 700,
}

/**
 * RULE: <METHOD>_<SHORT_DES>
 * EX: POST_CREATE_USER
 */

// Auth Api
export const POST_LOGIN = "/auth/login";
export const REGISTER_USER = "/auth/register";

// User Api
export const GET_USER = "/user/{uid}";
export const PUT_USER_UPDATE = "/user/{uid}";
export const PUT_USER_CHANGE_PASSWORD = "user/change-password";
export const GET_USER_LIST = "/user/list";
export const RESET_PASSWORD = "/user/reset-v030/{uid}";
export const GET_EXTERNAL_USER_LIST = "/user/external/list";

// Request Api
export const GET_INTERNAL_LIST = "/transfer_request/list";
export const PUT_UPDATE_REQUEST_STATUS = "/transfer_request/status";
export const GET_EXTERNAL_LIST = "/transfer_response/list";

// Application Api
export const GET_APPLICATIONS = "/application/list";
export const GET_APPLICATION_DETAIL = "/application/{uid}";
export const POST_APPLICATION_CREATE = "/application";
export const DELETE_APPLICATIONS = "/application";
export const PUT_APPLICATION_UPDATE = "/application/{uid}";

// Device Api
export const GET_DEVICE_LIST = "/device/list";

// Attachment Api
export const POST_ATTACHMENT_UPLOAD = "/attachment/upload";

// Queue
export const POST_QUEUE_IMPORT_RESPONSE = "/queue/import/response";
export const POST_QUEUE_IMPORT_REQUEST = "/queue/import/request";
export const GET_QUEUE_EXPORT_REQUEST = "/queue/export/request";
export const GET_QUEUE_EXPORT_RESPONSE = "/queue/export/response";

// Person
export const GET_PERSON_LIST = "/hook/person/list";

// Socket
export const SEND_NOTICE_TO_DATALAKE = "/socket/ph1";

// Ship
export const GET_SHIP_LIST = "/hook/ship_combine/list";
